import styled from 'styled-components';

export const Label = styled.div`
  display: flex;
  flex-direction: row;
`;

export const PendingIconContainer = styled.div`
  ${(props) => props.theme.config.typograph.xsmall};
  color: ${(props) => props.theme.config.colors.primary};
  display: block;
  background: ${(props) => props.theme.config.colors.primary_100};
  border-radius: 4px;
  padding: 0.6rem 0.8rem;
  width: fit-content;
`;
